import { Link } from "react-router-dom";

const navigation = {
  software: [
    { name: "LC Pack Review", href: "/lcopilot" },
    { name: "Sanctions Screening", href: "/sanctions" },
    { name: "CBAM Readiness", href: "/tools/cbam-readiness-check" },
    { name: "EUDR Readiness", href: "/tools/eudr-readiness-check" },
  ],
  managed: [
    { name: "Verified Trade Decision Pack", href: "/proofline" },
    { name: "Duty Audit", href: "/duty-audit" },
    { name: "Trade Audit", href: "/trade-audit" },
  ],
  resources: [
    { name: "All offerings", href: "/tools" },
    { name: "Documentation", href: "/docs" },
    { name: "API reference", href: "/api" },
    { name: "UCP 600 guide", href: "/guides/ucp600" },
  ],
  company: [
    { name: "About", href: "/about" },
    { name: "Contact", href: "/contact" },
    { name: "Careers", href: "/careers" },
  ],
  legal: [
    { name: "Privacy policy", href: "/privacy" },
    { name: "Terms of service", href: "/terms" },
    { name: "Security", href: "/security" },
  ],
};

function FooterLinks({
  title,
  links,
}: {
  title: string;
  links: Array<{ name: string; href: string }>;
}) {
  return (
    <div>
      <h3 className="mb-4 font-display font-semibold text-[#B2F273]">{title}</h3>
      <ul className="space-y-3">
        {links.map((item) => (
          <li key={item.name}>
            <Link
              to={item.href}
              className="font-mono text-xs uppercase tracking-wider text-[#EDF5F2]/60 transition-colors hover:text-white"
            >
              {item.name}
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
}

export function TRDRFooter() {
  return (
    <footer className="border-t border-[#EDF5F2]/10 bg-[#00261C]">
      <div className="container mx-auto px-4 py-12 sm:px-6 md:py-16 lg:px-8">
        <div className="mb-12 grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-6">
          <div className="md:col-span-2 lg:col-span-1">
            <Link to="/" className="mb-4 inline-block">
              <img src="/logo-dark-v2.png" alt="TRDR Hub" className="h-10 w-auto object-contain" />
            </Link>
            <p className="mb-4 text-sm leading-relaxed text-[#EDF5F2]/60">
              Trade compliance software and managed intelligence on one evidence platform.
            </p>
            <a
              href="mailto:hello@trdrhub.com"
              className="text-sm text-[#EDF5F2]/45 transition-colors hover:text-[#B2F273]"
            >
              hello@trdrhub.com
            </a>
          </div>

          <FooterLinks title="Software" links={navigation.software} />
          <FooterLinks title="Managed intelligence" links={navigation.managed} />
          <FooterLinks title="Resources" links={navigation.resources} />
          <FooterLinks title="Company" links={navigation.company} />
          <FooterLinks title="Legal" links={navigation.legal} />
        </div>

        <div className="flex flex-col-reverse items-center justify-between gap-4 border-t border-[#EDF5F2]/10 pt-8 md:flex-row">
          <p className="text-center text-sm text-[#EDF5F2]/40 md:text-left">
            © 2026 TRDR Hub. All rights reserved.
          </p>
          <a
            href="https://linkedin.com/company/trdrhub"
            target="_blank"
            rel="noopener noreferrer"
            className="text-[#EDF5F2]/45 transition-colors hover:text-[#B2F273]"
          >
            LinkedIn
          </a>
        </div>
      </div>
    </footer>
  );
}
